import { NavLink } from 'react-router-dom'
import { LayoutDashboard, Users, FileText, DollarSign, Activity } from 'lucide-react'
import { useCapacitor } from '@/hooks/useCapacitor'
import { cn } from '@/lib/utils'

const TABS = [
  { label: 'Dashboard',    icon: LayoutDashboard, to: '/app',             end: true  },
  { label: 'Vivier',       icon: Users,           to: '/app/vivier',      end: false },
  { label: 'Mandats',      icon: FileText,        to: '/app/mandats',     end: false },
  { label: 'Commissions',  icon: DollarSign,      to: '/app/commissions', end: false },
  { label: 'Activité',     icon: Activity,        to: '/app/activite',    end: false },
]

export default function MobileTabBar() {
  const { isNative } = useCapacitor()

  // La tab bar n'est affichée que sur les apps natives Capacitor
  if (!isNative) return null

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-slate-900 border-t border-gray-100 dark:border-slate-800 flex"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      {TABS.map(({ label, icon: Icon, to, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            cn(
              'flex-1 flex flex-col items-center justify-center py-2 gap-0.5 text-[10px] font-medium transition',
              isActive
                ? 'text-[#4F46E5]'
                : 'text-gray-400 dark:text-slate-500 hover:text-gray-600 dark:text-gray-400 dark:hover:text-slate-300',
            )
          }
        >
          {({ isActive }) => (
            <>
              <Icon
                size={22}
                className={isActive ? 'text-[#4F46E5]' : 'text-gray-400 dark:text-slate-500'}
              />
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
